export default __webpack_public_path__ + "static/6655-e3a50a37a8127f84ca7ba3c58376d121.jpg";